import { apiUrl } from "../utils/api";

/**
 * Arbeitgeber eines Privatkontakts (`PUT /contact/:id/arbeitgeber`).
 *
 * Eigene Ressource, weil der Arbeitgeber KEINE Spalte am Kontakt ist, sondern
 * die vorhandene Person↔Firma-Beziehung: Der Kontakt-PUT schreibt Stammdaten,
 * dieser Weg markiert eine Beziehung (und legt sie an, falls es noch keine
 * gibt). `firmaId: null` löst die Verknüpfung — der Freitextname am Kontakt
 * bleibt dabei unangetastet und wird danach wieder als Rückfallebene gezeigt.
 */
export interface ArbeitgeberAntwort {
  firmaId: number | null;
  firmaName: string | null;
}

export const arbeitgeberSetzen = async (
  contactId: number,
  firmaId: number | null,
): Promise<ArbeitgeberAntwort> => {
  // Bewusst rohes fetch mit Content-Type: apiFetch setzt keinen, der JSON-Body
  // käme sonst leer an — bei HTTP 200 (siehe utils/api).
  const res = await fetch(apiUrl(`contact/${contactId}/arbeitgeber`), {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ contactId: firmaId }),
  });
  if (!res.ok) throw new Error(`Arbeitgeber speichern fehlgeschlagen: HTTP ${res.status}`);
  return res.json();
};
